import axios from "../api/client"
import { useContext } from "react";
import { createContext, useState } from "react";

export const TrainersContext = createContext();

export function TrainersProvider({ children }) {
    const [trainers, setTrainers] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchTrainers = async () => {
        try {
            const response = await axios.get(`/tutor`);
            setTrainers(response.data);
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };
    
   

    return (
        <TrainersContext.Provider value={{ trainers, isLoading, error, fetchTrainers,  }}>
            {children}
        </TrainersContext.Provider>
    );
}
export const useContent = () => {
    const context = useContext(TrainersContext);
    if (!context) {
      throw new Error('useContent must be used within a ContentProvider');
    }
    return context;
};